import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=cb1daa18&scoped=true&lang=html&"
import script from "./groupList.vue?vue&type=script&lang=js&"
export * from "./groupList.vue?vue&type=script&lang=js&"
import style0 from "./groupList.vue?vue&type=style&index=0&id=cb1daa18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1daa18",
  null
  
)

export default component.exports